const routeConstant = {
  login: {
    path: "/login",
    title: "Login",
  },
  forgotPassword: {
    path: "/forgot-password",
    title: "Forgot Password",
  },
  resetPassword: {
    path: "/reset-password",
    title: "Reset Password",
  },
  dashboard: {
    path: "/dashboard/home",
    title: "Dashboard",
  },
  organizations: {
    path: "/dashboard/organiazations",
    title: "Organizations",
  },
  modifyQuestionnaire: {
    path: "/dashboard/modify-questionnaire",
    title: "Modify Questionnaire",
  },
  requestedEvaluation: {
    path: "/dashboard/requested-evaluations",
    title: "Requested Evaluations",
  },
  singleOrganizationRequestedEvaluation: {
    path: "/dashboard/pending-evaluation/:id",
    title: "Requested Evaluations",
  },
  continuePendingEvaluation: {
    path: "/dashboard/complete-evaluation/:id",
    title: "Complete Evaluation",
  },
  contact: {
    path: "/dashboard/support",
    title: "Support Requests",
  },
  organizationDetail: {
    path: "/dashboard/organization/:id",
    title: "Organization Evaluation Record List",
  },
  evaluationRecordDetail: {
    path: "/dashboard/organization/:org/evaluation-record/:id",
    title: "Record Details",
  },
  editEvaluationRecord: {
    path: "/dashboard/organization/:org/edit-evaluation/:id",
    title: "Edit Evaluation Record",
  },
  addOrganization: {
    path: "/dashboard/add-organization",
    title: "Add New Organization",
  },
  editOrganization: {
    path: "/dashboard/edit-organization/:id",
    title: "Edit Organizations",
  },
  document: {
    path: "/dashboard/my-document",
    title: "User Manual",
  },
};

export { routeConstant };
